import { Component, Input } from '@angular/core';
import { ComentariosService } from './comentarios.service';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { ComentarioInterface } from 'app/models/comentarios-model';
import { UserAvatarWidgetComponent } from "../../GlobalComponents/user-avatar-component";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'comentarios',
    templateUrl: 'comentarios.html',
    imports: [CommonModule, UserAvatarWidgetComponent, FormsModule, MatInputModule, MatButtonModule, ReactiveFormsModule, MatCheckboxModule],
})

export class ComentariosComponent  {

    @Input() entityUuid: string = ''

    comentarios$: Observable<ComentarioInterface[]>
    comentarioForm: FormGroup;

    constructor(private comentariosService: ComentariosService, private fb: FormBuilder) { 
        this.comentarios$ = comentariosService.comentarios$
        this.comentarioForm = this.fb.group({
            comentario: ['', [Validators.required]],
            notificar:  [false, [Validators.required]]
          });
    }

    
    agregarComentario(){
        //console.log(this.comentarioForm.value.comentario, this.comentarioForm.value.notificar)
        this.comentariosService.registrarComentario(this.entityUuid,  this.comentarioForm.value.comentario, this.comentarioForm.value.notificar)
        .then(response => {
            this.comentarioForm.reset();
        });
    }
}